module.exports = __webpack_public_path__ + "static/media/microphone.149721a2.svg";